export const accesos = [
    {
      desc: null,
      icon: 'rate_review',
      target: '_blank',
      title: 'REGISTRO DE TITULOS',
      url: 'https://educacion.sanjuan.edu.ar/mesj/Prensa/RegistrodeTítulos.aspx',
      color: "#ffae55"
    },
    {
      desc: null,
      icon: 'apartment',
      target: '_blank',
      title: 'UNIDADES DE GESTIÓN',
      url: 'https://educacion.sanjuan.edu.ar/mesj/Prensa/UnidaddeGestión.aspx',
      color: "#ffae55"
    },
    {
      desc: null,
      icon: 'groups',
      target: '_blank',
      title: 'DESIGNACIÓN DE DOCENTES',
      url: 'https://educacion.sanjuan.edu.ar/mesj/Prensa/DesignaciónDocente.aspx',
      color: "#ffae55"
    },
    {
      desc: null,
      icon: 'groups',
      target: '_blank',
      title: 'BAJAS Y LICENCIAS',
      url: 'https://educacion.sanjuan.edu.ar/mesj/Prensa/TrámitesBajasyLicencias.aspx',
      color: "#ffae55"
    },
    {
      desc: null,
      icon: 'inventory_2',
      target: '_blank',
      title: 'DESBLOQUEO DE NOTEBOOKS',
      url: 'https://educacion.sanjuan.edu.ar/mesj/Prensa/DesbloqueoNetbooks.aspx',
      color: "#ffae55"
    },
    {
      desc: null,
      icon: 'school',
      target: '_blank',
      title: 'CUERPO DE BANDERA MINIST. DE EDUCACIÓN',
      url: 'https://educacion.sanjuan.edu.ar/mesj/Prensa/ElecciónCuerpodeBandera.aspx',
      color: "#ffae55"
    }/*,
    {
      desc: null,
      icon: 'card_travel',
      target: '_blank',
      title: 'LICITACIONES',
      url: '?uid=frame-https://educacion.sanjuan.edu.ar/mesj/Prensa/Licitaciones.aspx',
      color: "#ffae55"
    },
    {
      desc: null,
      icon: 'Send',
      target: '_blank',
      title: 'SEGURO DE VIDA OBLIGATORIO',
      url: 'https://educacion.sanjuan.edu.ar/mesj/Prensa/SegurodeVida.aspx',
      color: "#ffae55"
    }*/
  ]